<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <g>
    <g>
      <circle class="cls-1" cx="27.79" cy="45.04" r="4.57"/>
      <circle class="cls-1" cx="40.47" cy="45.04" r="4.57"/>
      <circle class="cls-1" cx="53.14" cy="45.04" r="4.57"/>
      <circle class="cls-1" cx="65.81" cy="45.04" r="4.57"/>
    </g>
    <g>
      <circle class="cls-3" cx="27.79" cy="57.84" r="4.57"/>
      <circle class="cls-3" cx="40.47" cy="57.84" r="4.57"/>
      <circle class="cls-3" cx="53.14" cy="57.84" r="4.57"/>
    </g>
    <g>
      <circle class="cls-4" cx="27.79" cy="32.24" r="4.57"/>
      <circle class="cls-4" cx="40.47" cy="32.24" r="4.57"/>
    </g>
  </g>
  <path class="cls-2" d="m45.04,15c16.59,0,30.04,13.45,30.04,30.04s-13.45,30.04-30.04,30.04-30.04-13.45-30.04-30.04,13.45-30.04,30.04-30.04m0-3.41c-18.44,0-33.45,15.01-33.45,33.45s15.01,33.45,33.45,33.45,33.45-15.01,33.45-33.45S63.48,11.59,45.04,11.59h0Z"/>
</svg>
</template>

<script>
export default {
    name: "UnitsTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #0f5b71;
  }
  .cls-2 {
    fill: #66c8ca;
  }
  .cls-3 {
    fill: #59c5c7;
  }
  .cls-4 {
    fill: #cfeae0;
  }
</style>